import { render, staticRenderFns } from "./freezer-banner.vue?vue&type=template&id=3aff6d87&"
import script from "./freezer-banner.vue?vue&type=script&lang=js&"
export * from "./freezer-banner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports